import { INITIAL_FILE_UPLOAD_ANALYSIS_SELECTIONS } from "../file-analysis-form/consts";

export type LayoutType = "lg" | "xl" | undefined;

export type HandleUploadParams = {
  files: Array<File>;
  password?: string;
  uploadToTicloud?: boolean;
  rlcsParams?: Partial<{
    platform: string;
    geolocation: string;
    locale: string;
    timeout: number;
    sample_name: string;
    internet_simulation: boolean;
  }>;
  rlcsInteractive?: Partial<{
    platform: string;
    sample_name: string;
    timeout: number;
    geolocation: string;
    locale: string;
  }>;
  dynamicAnalysis?: string[];
  localOnly?: boolean;
  sources: {
    sourceTag?: string;
    fileOriginLink?: string;
  };
};

export type AnalysisSelections = typeof INITIAL_FILE_UPLOAD_ANALYSIS_SELECTIONS;
